const isImage = url => {
    if (!url) return false;
    return url.match(/\.(jpg|png|gif|jpeg|JPG|PNG|GIF|JPEG)(?=\?|$)/) !== null;
};

export default isImage;
